import React, { Component } from 'react';

class Login extends Component {
  render() {
    return (
      <div className="container" style={{ height: '100vh' }}>
        {this.props.children}
      </div>
    )
  }
}

export default Login;